// @ts-nocheck
import React, { useRef, useState } from 'react';
import { Form, Input, Button } from 'antd';
import { SendProblem } from '@components/sendProblem';
import { useAuthModules, AuthAliAwsc } from '@ywfe/authmodules';
import { YAuthProps } from './auth.interface';
import { ToolWrapStyle } from './styles';

export const Login: React.FC<YAuthProps> = (props: YAuthProps) => {
  const { onChangeType } = props;
  const { authLogin } = useAuthModules();
  const nameRef = useRef(null);
  const [slideInfo, setSlideInfo] = useState(null);
  const [slideState, setSlideState] = useState(false);
  const isLoginDisabled = slideInfo === null || slideInfo?.captchaVerifyParam === null||'';

  const onFinishNew = (values: any) => {
    const res = authLogin({
      ...values,
      ...slideInfo,
      grayPlatform: 'PC',
    });
    if (!res?.status) {
      setSlideState(true);
    }
  };

  const getSlideInFos = (opt: any) => {
    setSlideInfo(opt);
  };

  const reSetSlideStatus = () => {
    setSlideState(false);
  };

  return (
    <Form name="basic" onFinish={onFinishNew} initialValues={{ remember: true }}>
      <Form.Item name="account">
        <Input maxLength={20} ref={nameRef} placeholder="请输入手机号码/企业邮箱" />
      </Form.Item>

      <Form.Item name="userPasswd">
        <Input.Password placeholder="请输入账号密码" />
      </Form.Item>

      <Form.Item>
        <AuthAliAwsc width={290} success={getSlideInFos} reSetSlideStatus={reSetSlideStatus} slideState={slideState} />
      </Form.Item>

      <Form.Item>
        <Button size="large" type="primary" htmlType="submit" block disabled={isLoginDisabled} style={{ marginTop: 14 }}>
          登录
        </Button>
      </Form.Item>
      <Form.Item>
        <ToolWrapStyle>
          <SendProblem isIcon={0} />
          <Button type="text" onClick={() => onChangeType && onChangeType()}>
            忘记密码
          </Button>
        </ToolWrapStyle>
      </Form.Item>
    </Form>
  );
};
